import oovalLogo from "../images/OOVAL - bB.png";

export const LogoSmall = () => {
  return (
    <div className="logo-content-row">
      <p>Powered by</p>
      <img src={oovalLogo} alt="nologo" />
    </div>
  );
};
